import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHeader from "@/components/site/PageHeader";
import { FadeIn } from "@/components/motion";
import { FOCUS_AREAS } from "@/config/site";

export default function Services() {
  return (
    <div data-testid="services-page">
      <PageHeader
        eyebrow="Services"
        lines={["Support, shaped", "around each transition."]}
        intro="Homevia's detailed service offerings are being finalized and will be published on this page. Below are the areas of focus our transitional care work is built around."
        testid="services-heading"
      />

      <section className="px-6 pb-24 lg:px-10 lg:pb-32">
        <div className="mx-auto max-w-7xl">
          <div className="grid gap-6 md:grid-cols-2">
            {FOCUS_AREAS.map((area, i) => (
              <FadeIn key={area.num} delay={i * 0.1}>
                <div
                  data-testid={`service-area-${area.num}`}
                  className="group h-full rounded-3xl border border-olive/10 bg-white p-10 transition-all duration-500 hover:scale-[1.01] hover:border-teal/50"
                >
                  <div className="flex items-center justify-between">
                    <span className="font-display italic text-lg text-teal">({area.num})</span>
                  </div>
                  <h3 className="mt-8 font-serif text-3xl text-ink">{area.title}</h3>
                  <p className="mt-4 max-w-md leading-relaxed text-olive/70">{area.text}</p>
                </div>
              </FadeIn>
            ))}
          </div>

          <FadeIn delay={0.2}>
            <div className="mt-14 rounded-3xl border border-olive/10 bg-sand/60 p-10 lg:p-14">
              <div className="grid items-center gap-8 lg:grid-cols-12">
                <div className="lg:col-span-8">
                  <h2 className="font-serif text-3xl tracking-tight text-ink lg:text-4xl">
                    Wondering whether Homevia can help?
                  </h2>
                  <p className="mt-4 max-w-xl text-olive/75">
                    Every situation is different. The simplest way to find out is a short
                    conversation — tell us what's happening and we'll talk it through together.
                  </p>
                </div>
                <div className="flex flex-wrap gap-4 lg:col-span-4 lg:justify-end">
                  <Link
                    to="/consultation"
                    data-testid="services-consultation-btn"
                    className="inline-flex items-center gap-2 rounded-full bg-teal-deep px-7 py-3.5 text-sm font-bold text-cream transition-all duration-300 hover:bg-olive hover:shadow-xl"
                  >
                    Schedule a Consultation <ArrowRight className="h-4 w-4" />
                  </Link>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </section>
    </div>
  );
}
